<template>
  <div class="subscription-popup-container">
    <span class="close-modal" @click="$emit('close')">
      <Crossmark />
    </span>
    <FeatureSubscription class="feature-icon" />
    <h4>
      <b>You are currently on the {{ tiers[subscriptionTier] }} plan</b>
    </h4>
    <p>{{ text }}</p>
    <StandardSolidButton title="Upgrade now" @click="go()" />
  </div>
</template>

<script>
import StandardSolidButton from '@/components/UIElements/StandardSolidButton'
import Crossmark from '@/assets/icons/Crossmark'
import FeatureSubscription from '@/assets/icons/FeatureSubscription'
export default {
  name: 'SubscriptionModal',
  components: { StandardSolidButton, Crossmark, FeatureSubscription },
  data() {
    return {
      tiers: {
        FREE: 'Free',
        ESSENTIAL: 'Essential',
        PRO: 'Pro',
      },
    }
  },
  computed: {
    subscriptionTier() {
      return this.$store.getters.subscriptionTier
    },
    text() {
      const key = this.$store.state.subscriptionModalTexts.textToShow
      return this.$store.state.subscriptionModalTexts[key]
    },
  },
  methods: {
    go() {
      this.$emit('close')

      setTimeout(() => {
        this.$router.push({ name: 'pricing' })
      }, 1)
    },
  },
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';
.subscription-popup-container {
  position: relative;
  padding: 0 24px;
}

.feature-icon {
  margin-bottom: 32px;
}
h4 {
  margin-bottom: 1.125rem;
}
p {
  font-size: 1.125rem;
  line-height: 1.625rem;
  margin: 0 auto;
}
.close-modal {
  cursor: pointer;
  position: absolute;
  left: 0;
  top: -12px;

  svg {
    width: 12px;
    height: 12px;
  }
}

button {
  margin-top: 32px;
}
@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1200px) {
  .close-modal {
    svg {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
